(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('LicenseConfigurationController', ["$scope", "$q", "http", "$routeParams", "modulesManager", "routeHelper", "policyDao", "policyRuleConfig", "troubleshooting", "modals", "tablePaginationHelper", "defaultListConverter", "columnsHelper", "$timeout", "licensesManager", "rolesManager", function ($scope, $q, http, $routeParams, modulesManager, routeHelper, policyDao, policyRuleConfig, troubleshooting, modals, tablePaginationHelper, defaultListConverter, columnsHelper, $timeout, licensesManager, rolesManager) {
        $scope.model = {
            currentModule: $routeParams.module,
            licensed: [],
            unlicensed: [],
            modalShowCount: 0
        };
        $scope.enabledSaases = [];
        $scope.licensedNum = 0;
        $scope.filterBy = '';
        $scope.conditionData = 0;
        $scope.matchedCount = 0;
        var availableSaases = [
            'office365_emails',
            'google_mail'
        ];
        var eventsUpdating = {};
        var licensedNum = 0;
        $scope.options = {
            columns: [
                {
                    id: 'entity_id',
                    hidden: true,
                    primary: true
                },
                {
                    id: 'gui_label',
                    text: 'User'
                },
                {
                    id: 'gui_sub_label',
                    text: 'Email Address'
                },
                {
                    id: 'av_license_enabled',
                    text: 'License assigned',
                    converter: 'licenseStatusConverter',
                    dataClass: 'justify-center'
                },
                {
                    id: 'av_license_manual',
                    hidden: true
                }
            ],
            options: {
                checkboxes: true,
                defaultOrdering: {
                    columnName: 'gui_label',
                    order: 'desc'
                }
            }
        };
        var primaryIdx = columnsHelper.getPrimaryIdx($scope.options.columns);
        var licenseAssignedColumnIdx = columnsHelper.getIdxById($scope.options.columns, 'av_license_enabled');
        function initEvents(isForce) {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            _($scope.tableModel.data).each(function (row) {
                if (isForce || !eventsUpdating[row[primaryIdx].originalText]) {
                    if (row[licenseAssignedColumnIdx].originalText) {
                        eventsUpdating[row[primaryIdx].originalText] = 'license-enabled';
                    } else {
                        eventsUpdating[row[primaryIdx].originalText] = 'license-disabled';
                    }
                }
            });
        }
        function updateRowClasses() {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            _($scope.tableModel.data).each(function (row, idx) {
                $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                if (eventsUpdating[row[primaryIdx].originalText] && eventsUpdating[row[primaryIdx].originalText] === 'license-enabled') {
                    delete $scope.tableModel.rowClasses[idx].license_disabled;
                    $scope.tableModel.rowClasses[idx].license_enabled = true;
                } else {
                    delete $scope.tableModel.rowClasses[idx].license_enabled;
                    $scope.tableModel.rowClasses[idx].license_disabled = true;
                }
            });
        }
        function detectSelectedIds(ids) {
            var detection = {
                assigned: 0,
                unAssigned: 0
            };
            _(ids).each(function (id) {
                if (eventsUpdating[id] === 'license-enabled') {
                    detection.assigned++;
                } else if (eventsUpdating[id] === 'license-disabled') {
                    detection.unAssigned++;
                }
            });
            return detection;
        }
        $scope.tableOptions = {
            disableTop: true,
            disableTotalRows: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            reloadUuid: true,
            showWorkingIndicator: false,
            workingIndicatorDisableGui: true,
            saveState: true,
            pagesAround: 2,
            pagination: {
                pageSize: 10,
                ordering: {}
            },
            dropdownHeader: true,
            actions: [
                {
                    label: 'Assign',
                    display: 'button',
                    active: function () {
                        if ($scope.tableHelper && $scope.tableHelper.getSelectedIds().length > 0) {
                            var chk = detectSelectedIds($scope.tableHelper.getSelectedIds());
                            return chk.unAssigned !== 0;
                        }
                        return false;
                    },
                    execute: function () {
                        _($scope.tableHelper.getSelectedIds()).each(function (selectedId) {
                            if (eventsUpdating[selectedId] === 'license-disabled') {
                                eventsUpdating[selectedId] = 'license-enabled';
                                $scope.model.unlicensed = _($scope.model.unlicensed).reject(function (id) {
                                    return id === selectedId;
                                });
                                $scope.model.licensed.push(selectedId);
                                $scope.licensedNum = $scope.licensedNum + 1;
                                if ($scope.licensedNum > Number($scope.licensesLimit) && !$scope.model.modalShowCount) {
                                    modals.alert('You can\'t assign more than ' + $scope.licensesLimit + ' licenses.');
                                    $scope.model.modalShowCount++;
                                }
                                $scope.conditionData++;
                            }
                            updateRowClasses();
                            $scope.tableHelper.clearSelection();
                        });
                    }
                },
                {
                    label: 'Un-assign',
                    display: 'button',
                    active: function () {
                        if ($scope.tableHelper && $scope.tableHelper.getSelectedIds().length > 0) {
                            var chk = detectSelectedIds($scope.tableHelper.getSelectedIds());
                            return chk.assigned !== 0;
                        }
                        return false;
                    },
                    execute: function () {
                        _($scope.tableHelper.getSelectedIds()).each(function (selectedId) {
                            if (eventsUpdating[selectedId] === 'license-enabled') {
                                eventsUpdating[selectedId] = 'license-disabled';
                                $scope.model.licensed = _($scope.model.licensed).reject(function (id) {
                                    return id === selectedId;
                                });
                                $scope.model.unlicensed.push(selectedId);
                                $scope.licensedNum = $scope.licensedNum - 1;
                                $scope.conditionData++;
                            }
                            updateRowClasses();
                            $scope.tableHelper.clearSelection();
                        });
                    }
                },
                {
                    label: 'Discard',
                    display: 'button',
                    active: function () {
                        return $scope.model.licensed.length + $scope.model.unlicensed.length > 0;
                    },
                    execute: function () {
                        $scope.reload();
                    }
                },
                {
                    label: 'Save',
                    display: 'button',
                    active: function () {
                        return $scope.model.licensed.length + $scope.model.unlicensed.length > 0 && $scope.licensedNum <= $scope.licensesLimit;
                    },
                    execute: function () {
                        if ($scope.licensedNum > $scope.licensesLimit || $scope.model.licensed.length + $scope.model.unlicensed.length === 0) {
                            return;
                        }
                        var query = [];
                        if ($scope.model.unlicensed.length) {
                            query.push(policyDao.modifySaasIdentities($scope.model.currentModule, {
                                av_license_enabled: false,
                                users: $scope.model.unlicensed
                            }));
                        }
                        if ($scope.model.licensed.length) {
                            query.push(policyDao.modifySaasIdentities($scope.model.currentModule, {
                                av_license_enabled: true,
                                users: $scope.model.licensed
                            }));
                        }
                        return $q.all(query).then(function () {
                            modals.alert('Saved successfully!').then(function () {
                                $scope.reload();
                            });
                        });
                    }
                }
            ]
        };
        var refreshByFilter = function (filter) {
            $scope.filterBy = filter;
            $timeout(function () {
                $scope.model.showAssignAll = false;
                if ($scope.tableHelper) {
                    $scope.tableHelper.clearSelection();
                    $scope.tableHelper.reload();
                }
            });
        };
        $scope.onFilterByChange = function (filter) {
            refreshByFilter(filter);
        };
        $scope.showActionsContainer = function () {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                $scope.model.showAssignAll = false;
                return;
            }
            var finding = 0;
            _($scope.tableModel.data).each(function (row) {
                if (eventsUpdating[row[primaryIdx].originalText] === 'license-disabled') {
                    finding++;
                }
            });
            $scope.matchedCount = finding;
            $scope.model.showAssignAll = !!finding;
        };
        $scope.assignToAll = function () {
            var licensedCache = angular.copy($scope.model.licensed);
            _($scope.tableModel.data).each(function (row) {
                if (eventsUpdating[row[primaryIdx].originalText] === 'license-disabled') {
                    licensedCache.push(row[primaryIdx].originalText);
                }
            });
            if (licensedCache.length - $scope.model.licensed.length + $scope.licensedNum > $scope.licensesLimit) {
                licensedCache = [];
                return modals.alert('You can\'t assign more than ' + $scope.licensesLimit + ' licenses.');
            }
            $scope.licensedNum += licensedCache.length - $scope.model.licensed.length;
            _(licensedCache).each(function (val, idx) {
                eventsUpdating[val] = 'license-enabled';
                if (!$scope.model.licensed[idx]) {
                    $scope.model.licensed.push(val);
                }
            });
            $scope.conditionData++;
            updateRowClasses();
        };
        $scope.reload = function () {
            $scope.model.licensed = [];
            $scope.model.unlicensed = [];
            $scope.model.modalShowCount = 0;
            $scope.conditionData = 0;
            eventsUpdating = {};
            $scope.model.showAssignAll = false;
            $scope.filterBy = '';
            if ($scope.enabledSaases.length) {
                var currentModuleEnabled = _($scope.enabledSaases).find(function (saas) {
                    return saas.name === $scope.model.currentModule;
                });
                if (!currentModuleEnabled) {
                    routeHelper.redirectTo('license-configuration', { module: $scope.enabledSaases[0].name });
                    return;
                }
            } else {
                return;
            }
            return $q.allSettled([
                licensesManager.init(),
                policyDao.saasIdentities($scope.model.currentModule, {
                    av_license_enabled: true,
                    hide_groups: true
                }).pagination(0, 1).params({ hideO365SM: 1 })
            ]).then(function (responses) {
                $scope.licensesLimit = licensesManager.getLicensesBySaas($scope.model.currentModule);
                licensedNum = responses[1].value.data.total_rows || 0;
                if ($scope.licensesLimit) {
                    $scope.licensedNum = licensedNum;
                    $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                        return policyDao.saasIdentities($scope.model.currentModule, { hide_groups: true }).filter($scope.filterBy).pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, { columns: $scope.options.columns }).params({ hideO365SM: 1 });
                    }, function (tableModel) {
                        $scope.tableModel = tableModel;
                        initEvents(_(eventsUpdating).isEmpty());
                        updateRowClasses();
                    });
                } else {
                    $scope.tableModel = { data: [] };
                }
            });
        };
        modulesManager.init().then(function () {
            $scope.enabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                return _(availableSaases).contains(saas.name);
            }).map(function (saas) {
                return $.extend({ href: routeHelper.getHref('license-configuration', { module: saas.name }) }, saas);
            });
            $scope.reload();
        });
        function changeBarChart(licensedNum, licensesLimit) {
            var barLength = 0;
            if (licensesLimit) {
                barLength = licensedNum / Number(licensesLimit) * 100;
            }
            if (barLength > 100) {
                barLength = 100;
                angular.element('.chart-license-container').css('background-color', '#cc4125');
            } else {
                angular.element('.chart-license-container').css('background-color', '#2980b9');
            }
            angular.element('.chart-license-container').css('width', barLength.toString() + '%');
        }
        $scope.$watch('licensedNum', function (newVal, oldVal) {
            if (newVal != oldVal) {
                changeBarChart(newVal, $scope.licensesLimit);
            }
        });
        $scope.$on('license-status-switch', function (event, data) {
            // Switching licenses status is not allowed for read users
            if (!rolesManager.isActionAllowed([
                    'admin',
                    'user',
                    'operations'
                ])) {
                return modals.alert('You don\'t have permissions to assign or unassign licenses.', { title: 'Insufficient privileges' });
            }
            if (eventsUpdating[data.entityId] === 'license-enabled') {
                eventsUpdating[data.entityId] = 'license-disabled';
                $scope.model.licensed = _($scope.model.licensed).reject(function (id) {
                    return id === data.entityId;
                });
                $scope.model.unlicensed.push(data.entityId);
                $scope.licensedNum = $scope.licensedNum - 1;
                $scope.conditionData++;
            } else {
                eventsUpdating[data.entityId] = 'license-enabled';
                $scope.model.unlicensed = _($scope.model.unlicensed).reject(function (id) {
                    return id === data.entityId;
                });
                $scope.model.licensed.push(data.entityId);
                $scope.licensedNum = $scope.licensedNum + 1;
                if ($scope.licensedNum > Number($scope.licensesLimit) && !$scope.model.modalShowCount) {
                    modals.alert('You can\'t assign more than ' + $scope.licensesLimit + ' licenses.');
                    $scope.model.modalShowCount++;
                }
                $scope.conditionData++;
            }
            updateRowClasses();
        });
        $scope.$watch('model.currentModule', function (newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.conditionData = 0;
                routeHelper.redirectTo('license-configuration', { module: $scope.model.currentModule }, { replace: true });
                $scope.reload();
            }
        });
        $scope.$watch(function () {
            return $scope.tableModel && $scope.tableModel.data;
        }, function () {
            if ($scope.filterBy) {
                $scope.showActionsContainer();
            } else {
                $scope.model.showAssignAll = false;
            }
        });
        $scope.$on('$locationChangeStart', function (event, next) {
            if ($scope.conditionData) {
                event.preventDefault();
                return modals.confirm('Warning: Looks like you have some uncommitted changes, are you sure you want to leave the page?').then(function () {
                    $scope.conditionData = 0;
                    window.location.href = next;
                });
            }
        });
    }]);
}());